<template>
  <ContactForm :contact="contact" @submit="onSubmit($event)"></ContactForm>
</template>

<script>
  const dayList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  import ContactForm from './ContactForm';
  import ContactService from '../services/contact.service';

  export default {
    name: 'ContactAdd',
    components: {
      ContactForm
    },
    data() {
      return {
        contact: {
          contact_group_id: null,
          name: null,
          email: null,
          sms: null,
          enable_email_baseline: null,
          description: null,
          notif_from: '0000',
          notif_to: '2400',
          notif_day: dayList,
          notif_from_sms: '0000',
          notif_to_sms: '2400',
          notif_day_sms: dayList,
          batch_email: null,
          email_subject_prefix: null
        }
      };
    },
    methods: {
      onSubmit(event) {
        ContactService.create(event).then(() => {
          this.$router.push('/contact/list');
          this.$showSuccessMessage('Added Contact');
        });
      }
    }
  };
</script>

<style lang="scss" scoped></style>
